module.exports = __webpack_public_path__ + "img/lanbx_landbox.gm.d28ffc4.png";